import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/allCampaings.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.CLEAN_EXPORTED_DATA:
      return []
    case Actions.ADD_EXPORTED_DATA:
       return [...state, action.exportedData]
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}